import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import JobRejectionReasonPage from '@/features/jobs/job-rejection-reason';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/vagas/motivo-reprovacao/')({
  component: () => (
    <HomeGate>
      <JobRejectionReasonPage />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
